import { ATTACHMENT_VIEW } from '../constants';
import AttachmentsPolicy from './attachmentsPolicy';

class AttachmentPolicy extends AttachmentsPolicy {
  constructor({ permissions }, dataset, attachment) {
    super({ permissions }, dataset);
    this.attachment = attachment;
    this.canDownload = this.permissions.attachments.download
      && (this.allowManage
        || this.allowAttach
        || !!(attachment?.metadata?.viewing === ATTACHMENT_VIEW.downloadable.name)
      );
  }

  canIngest(datasourceFeatures) {
    return this.canConvert(datasourceFeatures) && this.attachment.valid_ingest_file_type;
  }
}

export default AttachmentPolicy;
